// removed by extract-text-webpack-plugin
module.exports = {"heroCarousel":"heroCarousel--3SQ-J","heroButton":"heroButton--3D0Nx","brandsSearchBar":"brandsSearchBar--10tc_"};


/*****************
 ** WEBPACK FOOTER
 ** ./apps/homepage/components/heroCarousel.scss
 ** module id = 1459
 ** module chunks = 17
 **/